export enum Status {
  None = 0,
  Voting = 10,
  Done = 20,
  Pending = 30,
}
